import { useEffect } from "react";
import { isEditableTarget } from "../lib/isEditableTarget";
import { navigate, routes } from "../lib/urls";

const chords: Record<string, Record<string, () => void>> = {
  g: {
    r: () => navigate(routes.recents),
    b: () => navigate(routes.branches),
    f: () => navigate(routes.favorites),
    c: () => navigate(routes.chats),
    p: () => navigate(routes.personal),
    o: () => navigate(routes.connectors),
    k: () => navigate(routes.skills),
    m: () => navigate(routes.monitoring),
    s: () => navigate(routes.settings),
    "1": () => navigate(routes.settings.featureFlags),
  },
};

export function useChordShortcuts() {
  useEffect(() => {
    let leader: string | null = null;
    let timer: ReturnType<typeof setTimeout> | null = null;

    function reset() {
      leader = null;
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
    }

    function handleKeyDown(e: KeyboardEvent) {
      if (isEditableTarget(e)) return;
      if (e.metaKey || e.ctrlKey || e.altKey) return;

      const key = e.key.toLowerCase();

      if (leader) {
        const action = chords[leader]?.[key];
        reset();
        if (action) {
          e.preventDefault();
          action();
        }
        return;
      }

      if (chords[key]) {
        leader = key;
        timer = setTimeout(reset, 1500);
      }
    }

    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      reset();
    };
  }, []);
}
